import { createApp } from "vue";
import html from "./archives.html";
import hash from "../../hash";

const js = ({
	url: function (echangeur) {
		//echangeur.addAction('b2b.toc.list', {}, '', 'toc');
		echangeur.addAction('b2b.linelist.readarchives', {}, '', 'archives');
	},
	onLoad: async function (echangeur) {
		const THIS = this;
		// const id = echangeur.hash._id


		let liste = [];
		// console.log(liste);


		// let lk = [];
		// echangeur.hash.k1
		let k1 = echangeur.hash.k1;
		let k2 = echangeur.hash.k2;
		let k3 = echangeur.hash.k3;


		// if(echangeur.hash.k1?.length>0) lk.push("k1") = echangeur.hash.k ;
		// if(echangeur.hash.k2?.length>0) lk["k2"] = echangeur.hash.k ;
		// if(echangeur.hash.k3?.length>0) lk["k3"] = echangeur.hash.k ;

		// let k4 = echangeur.hash.k1;
		//console.log(echangeur.hash)


		function testK(k, el) {
			return (el[k] == hash[k]);
		}

		// echangeur.archives.forEach(element => { 
		// 	if(testK(echangeur.hash,element) ) liste.push(element);
		// });

		let title = "Archives ";

		if (liste.length == 0) {
			echangeur.archives.forEach(element => {
				//console.log(element);
				// console.log(k1);

				if (k1 === undefined && element["k1"] !== undefined && element["k2"] === undefined) {

					//console.log(element["K1"]);
					liste.push(element);

				} else if (element["k1"] == k1 && k2 === undefined && element["k2"] !== undefined && element["k3"] === undefined) {
					title = "Archives - " + element["k1"];
					liste.push(element);

				} else if (element["k1"] == k1 && element["k2"] == k2 && k3 === undefined && element["k3"] !== undefined && element["file"] === undefined) {
					title = "Archives - " + element["k1"] + " - " + element["k2"];
					liste.push(element);

				} else if (element["k1"] == k1 && element["k2"] == k2 && k3 !== undefined && element["k3"] == k3 && element["file"] !== undefined) {
					title = "Archives - " + element["k1"] + " - " + element["k2"] + " - " + element["k3"];

					element.url = ["Archives", k1, k2, k3, element.file].join("/");
					liste.push(element);

				} else {

				}
			});
		}

		const app = createApp({

			data: function () {
				return {
					// id,
					title,
					datas: liste,
				}
			},
			methods: {
				back() {
					hash.back()
				},
				goTo: function (item) {
					let k = {};
					if (item["k1"]) k.k1 = item["k1"];
					if (item["k2"]) k.k2 = item["k2"];
					if (item["k3"]) k.k3 = item["k3"];
					hash.chaine("archives", { u: echangeur.hash.u, ...k });
				}
			},
			mounted() {
				//console.log(this.title);
			},

		});
		app.mount(THIS.c$('._vueChargement')[0]);
	},
	loader: function (echangeur) {

	},

});

export default {
	archives: { js: js, html: html }
};
